import { render } from "./OnboardingNew.vue?vue&type=template&id=f5c60988"
import script from "./OnboardingNew.vue?vue&type=script&lang=js"
export * from "./OnboardingNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/onboarding/OnboardingNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5c60988"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5c60988', __exports__)) {
    api.reload('f5c60988', __exports__)
  }
  
  module.hot.accept("./OnboardingNew.vue?vue&type=template&id=f5c60988", () => {
    api.rerender('f5c60988', render)
  })

}


export default __exports__